import {
    getVerifiedLocalTenantId,
    isCanonicalPostgresUuidText,
} from './local-tenant-database';

function readVerifiedTenantId(): string | null {
    const tenantId = getVerifiedLocalTenantId();
    return isCanonicalPostgresUuidText(tenantId)
        ? tenantId
        : null;
}

export function requireVerifiedTenantRuntimeId(): string {
    const tenantId = readVerifiedTenantId();
    if (tenantId) return tenantId;

    const error: any = new Error('The authenticated tenant must be verified before local browser state is available.');
    error.code = 'LOCAL_TENANT_SESSION_UNVERIFIED';
    throw error;
}

export function getVerifiedTenantBrowserKey(baseKey: unknown): string | null {
    const key = typeof baseKey === 'string' ? baseKey.trim() : '';
    if (!key) throw new TypeError('A non-empty browser storage key is required.');
    const tenantId = readVerifiedTenantId();
    return tenantId ? `${key}::${tenantId}` : null;
}

export const __testables__ = { readVerifiedTenantId };
